"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _material = require("@mui/material");
var _TooltipInfo = _interopRequireDefault(require("../TooltipInfo/TooltipInfo"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var NewPageTitle = function NewPageTitle(_ref) {
  var title = _ref.title,
    tooltip = _ref.tooltip;
  var ContainerTitle = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    @media (max-width: 425px) {\n      align-items: center;\n    }\n  "])));
  return /*#__PURE__*/_react["default"].createElement(ContainerTitle, null, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    sx: {
      fontSize: {
        xs: 18,
        sm: 20
      },
      fontWeight: '700'
    }
  }, title), /*#__PURE__*/_react["default"].createElement(_TooltipInfo["default"], {
    titleTooltip: tooltip
  }));
};
NewPageTitle.propTypes = {
  title: _propTypes["default"].string.isRequired,
  tooltip: _propTypes["default"].string
};
NewPageTitle.defaultProps = {
  tooltip: ''
};
var _default = exports["default"] = NewPageTitle;